<template>
  <v-container>
    <v-row
      ><v-col cols="0" lg="0" xl="1"></v-col
      ><v-col cols="12" lg="12" xl="10">
        <div class="text-center pt-16" v-if="isLoading">
          <v-progress-circular
            indeterminate
            color="blue-grey darken-1"
          ></v-progress-circular>
        </div>
        <v-data-table
          v-if="!isLoading"
          ref="vDataTable"
          v-model="selected"
          :headers="headers"
          :items="desserts"
          :single-expand="singleExpand"
          :expanded.sync="expanded"
          :search="search"
          item-key="ticketId"
          :items-per-page="-1"
        >
          <template v-slot:top>
            <v-toolbar
              :flat="offsetTop <= 0"
              style="
                position: sticky;
                top: 73px;
                background-color: #fff;
                z-index: 1;
              "
            >
              <v-toolbar-title>票券列表</v-toolbar-title>
              <v-divider class="mx-4" inset vertical></v-divider>
              <v-spacer></v-spacer>
              <v-dialog persistent v-model="dialog" max-width="960px">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    color="blue-grey lighten-1                                              "
                    style="height: 40px"
                    depressed
                    dark
                    class="mb-2 mt-2"
                    @click="next()"
                    v-if="lastVisible"
                  >
                    載入更多
                  </v-btn>
                  <v-btn
                    color="blue-grey"
                    style="height: 40px"
                    depressed
                    dark
                    class="mb-2 mt-2 mr-2"
                    @click="exportExcel()"
                  >
                    匯出 Excel </v-btn
                  ><v-spacer></v-spacer>
                  <v-btn
                    color="blue-grey"
                    dark
                    depressed
                    style="height: 40px"
                    class="mb-2 mt-2"
                    v-bind="attrs"
                    v-on="on"
                    v-if="false"
                  >
                    新增 </v-btn
                  ><v-btn
                    color="blue-grey"
                    style="height: 40px"
                    depressed
                    dark
                    class="mb-2 mt-2 mr-2"
                    @click="daysBeforeExpiration = null"
                  >
                    清除 </v-btn
                  ><v-text-field
                    v-model="daysBeforeExpiration"
                    label="天數"
                    class="mr-2"
                    style="height: 40px; width: 44px"
                    outlined
                    dense
                  ></v-text-field>
                  <v-divider class="mx-4" inset vertical></v-divider>
                  <v-toolbar-title>即將過期查詢</v-toolbar-title>
                  <v-spacer></v-spacer
                  ><v-btn
                    color="blue-grey"
                    style="height: 40px"
                    dark
                    class="mb-2 mt-2 ml-2"
                    @click="clearQuery()"
                  >
                    清除
                  </v-btn>
                  <v-btn
                    color="blue-grey"
                    dark
                    style="height: 40px"
                    class="mb-2 mt-2 ml-2"
                    @click="queryBy()"
                  >
                    依類別搜尋
                  </v-btn>
                  <v-select
                    label="形式"
                    v-model="searchUitype"
                    :items="searchUitypes"
                    class="ml-3"
                    style="max-width: 100px"
                    item-text="text"
                    item-value="text"
                    return-object
                    outlined
                    dense
                    hide-details="true"
                    :disabled="!searchType.value"
                  ></v-select>
                  <v-select
                    label="狀態"
                    v-model="searchUseType"
                    :items="searchUseTypes"
                    class="ml-3"
                    style="max-width: 100px"
                    item-text="text"
                    item-value="text"
                    return-object
                    outlined
                    dense
                    hide-details="true"
                    :disabled="!searchType.value"
                  ></v-select>
                  <v-select
                    label="類別"
                    v-model="searchType"
                    :items="searchTypes"
                    class="ml-3"
                    style="max-width: 150px"
                    item-text="text"
                    item-value="text"
                    return-object
                    outlined
                    dense
                    hide-details="true"
                  ></v-select>
                  <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    style="max-width: 150px"
                    label="Search"
                    single-line
                    hide-details
                    :disabled="!searchType.searchAble"
                  ></v-text-field>
                </template>
                <v-card>
                  <v-toolbar color="primary" dark>
                    <v-toolbar-title>{{ formTitle }}</v-toolbar-title>

                    <v-spacer></v-spacer>

                    <v-btn icon @click="dialog = false">
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </v-toolbar>

                  <v-card-text class="pt-6">
                    <v-container>
                      <v-form ref="form" v-model="valid" lazy-validation>
                        <v-row>
                          <v-col cols="12" md="3">
                            <v-menu
                              v-model="releaseDateMenu"
                              :close-on-content-click="false"
                              :nudge-right="40"
                              transition="scale-transition"
                              offset-y
                              min-width="auto"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                  v-model="template.releaseDate"
                                  label="發佈日期"
                                  prepend-icon="mdi-calendar"
                                  readonly
                                  v-bind="attrs"
                                  v-on="on"
                                  dense
                                  outlined
                                  hide-details="true"
                                  required
                                  :disabled="editedIndex > -1"
                                ></v-text-field>
                              </template>
                              <v-date-picker
                                v-model="template.releaseDate"
                                no-title
                                @input="releaseDateMenu = false"
                              ></v-date-picker>
                            </v-menu>
                          </v-col>
                          <v-col cols="12" md="3">
                            <v-menu
                              v-model="expiredDateMenu"
                              :close-on-content-click="false"
                              :nudge-right="40"
                              transition="scale-transition"
                              offset-y
                              min-width="auto"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                  v-model="template.expiredDate"
                                  label="過期日期"
                                  prepend-icon="mdi-calendar"
                                  readonly
                                  v-bind="attrs"
                                  v-on="on"
                                  dense
                                  outlined
                                  hide-details="true"
                                  :disabled="editedIndex > -1"
                                ></v-text-field>
                              </template>
                              <v-date-picker
                                v-model="template.expiredDate"
                                no-title
                                @input="expiredDateMenu = false"
                              ></v-date-picker>
                            </v-menu>
                          </v-col>
                          <v-col cols="12" md="3">
                            <v-menu
                              v-model="contractExpiredDateMenu"
                              :close-on-content-click="false"
                              :nudge-right="40"
                              transition="scale-transition"
                              offset-y
                              min-width="auto"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                  v-model="template.contractExpiredDate"
                                  label="合約效期"
                                  prepend-icon="mdi-calendar"
                                  readonly
                                  v-bind="attrs"
                                  v-on="on"
                                  dense
                                  outlined
                                  hide-details="true"
                                  :disabled="editedIndex > -1"
                                ></v-text-field>
                              </template>
                              <v-date-picker
                                v-model="template.contractExpiredDate"
                                no-title
                                @input="contractExpiredDateMenu = false"
                              ></v-date-picker>
                            </v-menu>
                          </v-col>
                          <v-col cols="12" md="3">
                            <v-text-field
                              v-model="template.verificationCode"
                              label="驗證碼"
                              hide-details="true"
                              dense
                              outlined
                              :disabled="editedIndex > -1"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" md="3">
                            <v-select
                              label="票券種類"
                              v-model="template.ticketKind"
                              :items="types"
                              item-text="text"
                              item-value="value"
                              outlined
                              dense
                              hide-details="true"
                              :disabled="editedIndex > -1"
                            ></v-select>
                          </v-col>

                          <v-col cols="12" md="3">
                            <v-text-field
                              v-model="template.ticketNo"
                              label="票券編號"
                              hide-details="true"
                              dense
                              outlined
                              :disabled="editedIndex > -1"
                            ></v-text-field> </v-col
                          ><v-col cols="12" md="3">
                            <v-text-field
                              v-model="template.ticketGroup"
                              label="票券群組"
                              hide-details="true"
                              dense
                              outlined
                              :disabled="editedIndex > -1"
                            ></v-text-field> </v-col
                          ><v-col cols="12" md="3">
                            <v-checkbox
                              v-model="template.beUsed"
                              label="已使用"
                              class="mt-1"
                              hide-details="true"
                            ></v-checkbox>
                          </v-col>
                          <v-col cols="12" md="6">
                            <v-text-field
                              v-model="template.ticketName"
                              label="票券名稱"
                              hide-details="true"
                              dense
                              outlined
                              :disabled="editedIndex > -1"
                            ></v-text-field>
                          </v-col>
                          <v-col
                            cols="12"
                            class="col-md-3"
                            v-show="editedIndex > -1"
                          >
                            <v-text-field
                              v-model="template.userNo"
                              :counter="10"
                              label="員工編號"
                              hide-details="true"
                              dense
                              outlined
                              required
                              :disabled="editedIndex > -1"
                            ></v-text-field>
                          </v-col>
                          <v-col
                            cols="12"
                            class="col-md-3"
                            v-show="editedIndex > -1"
                          >
                            <v-text-field
                              v-model="template.compNo"
                              :counter="10"
                              label="公司編號"
                              hide-details="true"
                              dense
                              outlined
                              :disabled="editedIndex > -1"
                            ></v-text-field>
                          </v-col>

                          <v-col cols="12" class="col-md-6">
                            <v-text-field
                              v-model="template.compaignName"
                              :counter="10"
                              label="活動名稱"
                              hide-details="true"
                              dense
                              outlined
                              :disabled="editedIndex > -1"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" class="col-md-6">
                            <v-text-field
                              v-model="template.url"
                              label="網址"
                              hide-details="true"
                              dense
                              outlined
                              :disabled="editedIndex > -1"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12" md="12">
                            <v-textarea
                              v-model="template.compaignDescription"
                              label="活動說明"
                              hide-details="true"
                              dense
                              outlined
                              :disabled="editedIndex > -1"
                            ></v-textarea>
                          </v-col> </v-row
                      ></v-form>
                      <!--<v-row v-if="!(editedIndex > -1)">
                        <v-col cols="12" md="12">
                          <template>
                            <v-data-table
                              dense
                              v-model="usersSelected"
                              :search="searchUser"
                              :headers="usersHeaders"
                              :items="usersFilter"
                              :single-select="singleSelect"
                              item-key="phoneNumber"
                              show-select
                              class="elevation-1"
                              :items-per-page="15"
                            >
                              <template v-slot:top>
                                <div
                                  class="d-flex justify-space-around align-center"
                                >
                                  <div
                                    class="text-h6 font-weight-bold grey--text text--darken-2 px-4 py-3 mt-0"
                                  >
                                    選擇傳送對象
                                  </div>
                                  <v-spacer></v-spacer>
                                  <v-text-field
                                    class="ma-0 mb-1 pa-0"
                                    v-model="searchUser"
                                    append-icon="mdi-magnify"
                                    label="Search"
                                    single-line
                                    hide-details
                                    dense
                                  ></v-text-field>
                                  <v-spacer></v-spacer>
                                  <v-checkbox
                                    v-model="genderFilter"
                                    label="男生"
                                    value="男生"
                                    class="pa-3 mt-0"
                                    hide-details="true"
                                    dense
                                  ></v-checkbox>
                                  <v-checkbox
                                    v-model="genderFilter"
                                    label="女生"
                                    value="女生"
                                    class="pa-3 mt-0"
                                    hide-details="true"
                                    dense
                                  ></v-checkbox>
                                  <v-checkbox
                                    v-model="genderFilter"
                                    label="其他"
                                    value=""
                                    class="pa-3 mt-0"
                                    hide-details="true"
                                    dense
                                  ></v-checkbox>
                                </div>
                              </template>
                            </v-data-table>
                          </template>
                        </v-col>
                      </v-row>-->
                    </v-container>
                  </v-card-text>
                  <v-divider></v-divider>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="close">
                      {{ !(editedIndex > -1) ? "取消" : "關閉" }}
                    </v-btn>
                    <v-btn color="blue darken-1" text @click="save">
                      儲存
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
              <v-dialog v-model="dialogDelete" max-width="500px">
                <v-card>
                  <v-card-title class="text-h5">確定要移除此項目?</v-card-title>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="closeDelete"
                      >取消</v-btn
                    >
                    <v-btn color="blue darken-1" text @click="deleteItemConfirm"
                      >確認</v-btn
                    >
                    <v-spacer></v-spacer>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-toolbar>
          </template>
          <template v-slot:[`item.sendTitle`]="{ item }">
            {{ item.sendTitle.trim().substr(0, 40) }}
          </template>
          <template v-slot:[`item.sendMessage`]="{ item }">
            {{ item.sendMessage.trim().substr(0, 40) }}...
          </template>
          <template v-slot:[`item.scheduleSendDate`]="{ item }">
            {{ item.scheduleSendDate[0] }} {{ item.scheduleSendDate[1] }}
          </template>
          <template v-slot:[`item.redirectUrl`]="{ item }">
            <v-btn icon :href="item.redirectUrl" target="_blank">
              <v-icon> mdi-link </v-icon>
            </v-btn>
          </template>
          <template v-slot:[`item.beUsed`]="{ item }">
            <v-simple-checkbox
              v-model="item.beUsed"
              class="ml-3"
              :ripple="false"
              disabled
            ></v-simple-checkbox>
          </template>
          <template v-slot:[`item.alreadyRead`]="{ item }">
            <v-simple-checkbox
              v-model="item.alreadyRead"
              class="ml-3"
              :ripple="false"
              disabled
            ></v-simple-checkbox>
          </template>
          <template v-slot:[`item.actionsEdit`]="{ item }">
            <v-icon @click="editItem(item)" style="font-size: 19px">
              mdi-pencil
            </v-icon>
            <!--<v-icon small @click="deleteItem(item)"> mdi-delete </v-icon>-->
          </template>
          <template v-slot:[`item.actionsDel`]="{ item }">
            <v-icon small @click="deleteItem(item)"> mdi-delete </v-icon>
          </template>
          <template v-slot:[`item.data-table-expand`]="props">
            <v-icon
              :class="{
                'v-data-table__expand-icon': true,
                'v-data-table__expand-icon--active':
                  props.isExpanded && transitioned[getItemId(props.item)],
              }"
              @click="toggleExpand(props)"
            >
              mdi-chevron-down
            </v-icon>
          </template>

          <!--展開內容-->
          <template v-slot:[`expanded-item`]="{ headers, item }">
            <td
              :colspan="headers.length"
              :class="{
                'ma-0 pa-0': true,
                'expanded-closing': !transitioned[getItemId(item)],
              }"
              style="height: auto"
            >
              <v-expand-transition>
                <div v-show="transitioned[getItemId(item)]">
                  <div class="pa-2" style="min-height: 100px">
                    <!--<span>{{ item }}</span>-->
                    <v-form>
                      <v-container class="my-6">
                        <v-row>
                          <v-col cols="12" md="4">
                            <v-img
                              style="
                                filter: grayscale(0.8);
                                width: 98%;
                                max-width: 1000px;
                              "
                              :lazy-src="
                                item.mainPictureUrl
                                  ? item.mainPictureUrl
                                  : 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSQpHJiI1b1zcEGg3vmY4zQ0OOsFI2GKyUmiw&usqp=CAU'
                              "
                              :src="
                                item.mainPictureUrl
                                  ? item.mainPictureUrl
                                  : 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSQpHJiI1b1zcEGg3vmY4zQ0OOsFI2GKyUmiw&usqp=CAU'
                              "
                              cover
                            ></v-img>
                          </v-col>
                          <v-col cols="12" md="8">
                            <div class="d-flex justify-space-between">
                              <div>
                                <div
                                  class="grey--text text--darken-1 text-subtitle-2 mb-2 font-weight-regular"
                                >
                                  活動日期 {{ item.startDate }} -
                                  {{ item.startDate }}
                                </div>
                                <p
                                  class="text-h4 font-weight-black text--primary mb-1"
                                >
                                  {{ item.storeName }}
                                </p>
                                <div
                                  class="font-weight-black font-weight-medium grey--text text--darken-2 text-h6 mb-10"
                                >
                                  台南市
                                </div>
                              </div>
                              <div>
                                <v-img
                                  max-width="200"
                                  style="opacity: 0.5"
                                  :lazy-src="
                                    item.logoUrl
                                      ? item.logoUrl
                                      : 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSQpHJiI1b1zcEGg3vmY4zQ0OOsFI2GKyUmiw&usqp=CAU'
                                  "
                                  :src="
                                    item.logoUrl
                                      ? item.logoUrl
                                      : 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSQpHJiI1b1zcEGg3vmY4zQ0OOsFI2GKyUmiw&usqp=CAU'
                                  "
                                ></v-img>
                              </div>
                            </div>
                            <hr
                              class="v-divider theme--light border-dashed mb-4"
                              style="border-style: dashed"
                            />
                            <v-row>
                              <v-col cols="12" md="6">
                                <p
                                  class="text-subtitle-2 font-weight-black mb-1"
                                >
                                  網站
                                </p>
                                <div
                                  class="text-subtitle-1 grey--text text--darken-2 mb-4"
                                  style="word-break: break-all"
                                >
                                  {{ item.webSiteUrl }}
                                </div>
                                <p
                                  class="text-subtitle-2 font-weight-black mb-1"
                                >
                                  電話
                                </p>
                                <div
                                  class="text-subtitle-1 grey--text text--darken-2 mb-4"
                                >
                                  {{ item.phone }}
                                </div>
                                <p
                                  class="text-subtitle-2 font-weight-black mb-1"
                                >
                                  簡介
                                </p>
                                <div
                                  class="text-subtitle-1 grey--text text--darken-2 mb-2"
                                  style="
                                    text-align: justify;
                                    word-break: break-all;
                                  "
                                >
                                  {{ item.description }}
                                </div>
                              </v-col>
                              <v-col cols="6"
                                ><v-row no-gutters>
                                  <v-col cols="12" md="6">
                                    <p
                                      class="text-subtitle-2 font-weight-black mb-1"
                                    >
                                      編號
                                    </p>
                                    <div
                                      class="text-subtitle-1 grey--text text--darken-2 mb-4"
                                    >
                                      No.{{ item.storeNo }}
                                    </div></v-col
                                  ><v-col cols="12" md="6">
                                    <p
                                      class="text-subtitle-2 font-weight-black mb-1"
                                    >
                                      分類
                                    </p>
                                    <div
                                      class="text-subtitle-1 grey--text text--darken-2 mb-4"
                                    >
                                      住
                                    </div></v-col
                                  >
                                </v-row>
                                <v-row no-gutters>
                                  <v-col cols="12" md="6">
                                    <p
                                      class="text-subtitle-2 font-weight-black mb-1"
                                    >
                                      啟用
                                    </p>
                                    <div
                                      class="text-subtitle-1 grey--text text--darken-2 mb-4"
                                    >
                                      {{ item.shouldDisplay }}
                                    </div></v-col
                                  ><v-col cols="12" md="6">
                                    <p
                                      class="text-subtitle-2 font-weight-black mb-1"
                                    >
                                      到期
                                    </p>
                                    <div
                                      class="text-subtitle-1 grey--text text--darken-2 mb-2"
                                    >
                                      {{ item.expired }}
                                    </div></v-col
                                  >
                                </v-row>
                                <p
                                  class="text-subtitle-2 font-weight-black mb-1"
                                >
                                  座標
                                </p>
                                <div
                                  class="text-subtitle-1 grey--text text--darken-2 mb-4"
                                >
                                  緯度 : {{ item.lat
                                  }}<v-spacer></v-spacer> 經度 :
                                  {{ item.lng }}
                                </div>
                              </v-col>
                            </v-row></v-col
                          >
                        </v-row>
                      </v-container>
                    </v-form>
                  </div>
                </div>
              </v-expand-transition>
            </td>
          </template>
        </v-data-table></v-col
      ><v-col cols="0" lg="0" xl="1"></v-col
    ></v-row>
  </v-container>
</template>

<script>
import ExcelJs from "exceljs";
import { db, functions } from "@/firebase";
import { httpsCallable } from "firebase/functions";
import {
  query,
  where,
  collection,
  getDocs,
  setDoc,
  doc,
  deleteDoc,
  documentId,
  orderBy,
  startAfter,
  limit,
} from "firebase/firestore/lite";

String.prototype.bool = function () {
  return /^true$/i.test(this);
};

export default {
  data: () => ({
    isLoading: true,
    offsetTop: 0,
    daysBeforeExpiration: null,
    releaseDateMenu: false,
    expiredDateMenu: false,
    contractExpiredDateMenu: false,
    sendImmediately: null,
    isSendImmediately: [true, false],
    valid: true,
    search: "",
    searchUser: "",
    singleSelect: true,
    selected: [],
    expanded: [],
    singleExpand: false,
    dialog: false,
    dialogDelete: false,
    searchType: { value: false, searchAble: true },
    searchTypes: [
      {
        text: "對象",
        value: true,
        collection: "userNo",
        searchAble: true,
        expression: "==",
        stringSearchValue: "",
        searchValue: "",
      },
      {
        text: "票券編號",
        value: true,
        collection: "ticketNo",
        searchAble: true,
        expression: "==",
        stringSearchValue: "",
        searchValue: "",
      },
      {
        text: "票券群組",
        value: true,
        collection: "ticketGroup",
        searchAble: true,
        expression: "==",
        stringSearchValue: "",
        searchValue: "",
      },
      {
        text: "已編列對象",
        value: true,
        collection: "userNo",
        searchAble: false,
        expression: "!=",
        stringSearchValue: "",
        searchValue: "",
      },
      {
        text: "未編列對象",
        value: true,
        collection: "userNo",
        searchAble: false,
        expression: "==",
        stringSearchValue: "",
        searchValue: "",
      },
      {
        text: "已使用",
        value: true,
        collection: "beUsed",
        searchAble: false,
        expression: "==",
        stringSearchValue: "",
        searchValue: true,
      },
      {
        text: "未使用",
        value: true,
        collection: "beUsed",
        searchAble: false,
        expression: "==",
        stringSearchValue: "",
        searchValue: false,
      },
    ],
    searchUseType: { value: false, searchAble: true },
    searchUseTypes: [
      {
        text: "已使用",
        value: true,
        collection: "beUsed",
        searchAble: false,
        expression: "==",
        stringSearchValue: "",
        searchValue: true,
      },
      {
        text: "未使用",
        value: true,
        collection: "beUsed",
        searchAble: false,
        expression: "==",
        stringSearchValue: "",
        searchValue: false,
      },
    ],
    searchUitype: { value: false, searchAble: true },
    searchUitypes: [
      {
        text: "code",
        value: true,
        collection: "uiType",
        searchAble: false,
        expression: "==",
        stringSearchValue: "",
        searchValue: "code",
      },
      {
        text: "link",
        value: true,
        collection: "uiType",
        searchAble: false,
        expression: "==",
        stringSearchValue: "",
        searchValue: "link",
      },
    ],
    types: [
      { text: "生日禮", value: "birthdayGift" },
      { text: "新店家上架", value: "newStore" },
      { text: "禮券", value: "gift" },
      { text: "公告", value: "notify" },
    ],
    headers: [
      // { text: "編號", value: "ticketId", width: "4%" },
      { text: "分類", align: "start", value: "ticketKind", width: "4%" },
      { text: "活動名稱", align: "start", value: "compaignName" },
      { text: "票券名稱", align: "start", value: "ticketName" },
      // {
      //   text: "活動說明",
      //   align: "start",
      //   value: "compaignDescription",
      // },
      { text: "公司", value: "compNo", sortable: false, width: "4%" },
      { text: "對象", value: "userNo", sortable: false, width: "4%" },
      {
        text: "票券編號",
        value: "ticketNo",
        align: "start",
        sortable: false,
        width: "8%",
      },
      {
        text: "票券群組",
        value: "ticketGroup",
        align: "start",
        sortable: false,
        width: "8%",
      },
      { text: "票券形式", value: "uiType", align: "center", width: "8%" },
      { text: "過期日期", value: "expiredDate", align: "center", width: "8%" },
      {
        text: "合約效期",
        value: "contractExpiredDate",
        align: "center",
        width: "8%",
      },
      {
        text: "已使用",
        value: "beUsed",
        align: "center",
        sortable: false,
        width: "5%",
      },
      // {
      //   text: "網址",
      //   value: "url",
      //   sortable: false,
      //   width: "6%",
      // },
      {
        text: "編輯",
        value: "actionsEdit",
        sortable: false,
        align: "center",
        width: "5%",
      },
      // {
      //   text: "刪除",
      //   value: "actionsDel",
      //   sortable: false,
      //   align: "center",
      //   width: "6%",
      // },
    ],
    usersSelected: [],
    usersHeaders: [
      { text: "所屬公司", value: "compName" },
      { text: "公司編號", value: "compNo" },
      { text: "員工編號", value: "userNo" },
      { text: "性別", value: "gender" },
      { text: "手機號碼", value: "phoneNumber" },
    ],
    desserts: [],
    users: [],
    editedIndex: -1,
    defaultItem: { scheduleSendDate: [] },
    template: { scheduleSendDate: [] },
    transitioned: [],
    closeTimeouts: {},
    genderFilter: ["男生", "女生", ""],
    usersFilter: [],
    lastVisible: {},
  }),
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "新增" : "編輯";
    },
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
    singleExpand(v) {
      if (!v) return;
      // Single expand enabled. Hide all but the first expanded item
      this.expanded.forEach((item, i) => {
        if (i > 0) this.closeExpand(item);
      });
    },
    genderFilter() {
      if (this.genderFilter.length >= 3) {
        this.usersFilter = this.users;
      } else {
        let result = this.users.filter((item) =>
          this.genderFilter.includes(item.gender)
        );
        this.usersFilter = result;
      }
    },
    daysBeforeExpiration() {
      this.expiredVerification();
    },
    searchType() {
      this.search = this.searchType.stringSearchValue;
    },
  },

  created() {
    this.$bus.$emit("sideBarSelectedItem:push", 8);
    this.getTickets();
    // this.getUsers();
    // console.log(this.formatDate(new Date()));
    // console.log(this.formatTime(new Date()));
    window.addEventListener("scroll", this.handleScroll);
  },

  methods: {
    test() {
      const callSendMessageToken = httpsCallable(
        functions,
        "callSendMessageToken"
      );
      callSendMessageToken({
        USER_ID: "11010160",
        PUSH_TITLE: "call 15:14",
        PUSH_BODY: "as title",
        PUSH_REDIRECT: "https://unilife.pec.com.tw",
      }).then((result) => {
        const data = result.data;
        console.log(data);
      });
    },
    async queryBy() {
      if (this.searchType.value) {
        if (!this.searchType.searchAble || this.search) {
          this.desserts = [];
          const usersRef = collection(db, "tickets");
          let q;
          if (this.searchUseType.value && this.searchUitype.value) {
            q = query(
              usersRef,
              where(
                this.searchType.collection,
                this.searchType.expression,
                this.searchType.searchAble
                  ? this.search
                  : this.searchType.searchValue
              ),
              where(
                this.searchUseType.collection,
                this.searchUseType.expression,
                this.searchUseType.searchValue
              ),
              where(
                this.searchUitype.collection,
                this.searchUitype.expression,
                this.searchUitype.searchValue
              )
            );
          } else if (this.searchUseType.value) {
            q = query(
              usersRef,
              where(
                this.searchType.collection,
                this.searchType.expression,
                this.searchType.searchAble
                  ? this.search
                  : this.searchType.searchValue
              ),
              where(
                this.searchUseType.collection,
                this.searchUseType.expression,
                this.searchUseType.searchValue
              )
            );
          } else if (this.searchUitype.value) {
            q = query(
              usersRef,
              where(
                this.searchType.collection,
                this.searchType.expression,
                this.searchType.searchAble
                  ? this.search
                  : this.searchType.searchValue
              ),
              where(
                this.searchUitype.collection,
                this.searchUitype.expression,
                this.searchUitype.searchValue
              )
            );
          } else {
            q = query(
              usersRef,
              where(
                this.searchType.collection,
                this.searchType.expression,
                this.searchType.searchAble
                  ? this.search
                  : this.searchType.searchValue
              )
            );
          }

          const documentSnapshots = await getDocs(q);
          documentSnapshots.forEach((doc) => {
            let data;
            data = JSON.parse(JSON.stringify(doc.data()));
            console.log(doc.id, " => ", doc.data());
            this.desserts.push(data);
          });
          if (this.desserts.length === 0) {
            this.$snackbar.add(`暫時沒有符合的資料`, { color: "error" });
          }
        } else {
          this.$snackbar.add(`請輸入搜尋內容`, { color: "error" });
        }
      } else {
        this.$snackbar.add(`請選擇搜尋類別`, { color: "error" });
      }
    },
    clearQuery() {
      this.desserts = [];
      this.search = "";
      this.searchType = {
        value: false,
        searchAble: true,
        stringSearchValue: "",
      };
      this.getTickets();
    },
    // async getUsers() {
    //   const querySnapshot = await getDocs(collection(db, "users"));
    //   querySnapshot.forEach((doc, index) => {
    //     let data;
    //     // doc.data() is never undefined for query doc snapshots
    //     // console.log(doc.id, " => ", doc.data());
    //     data = JSON.parse(JSON.stringify(doc.data()));
    //     if (data.userNo) {
    //       data.no = index;
    //       this.users.push(data);
    //     }
    //   });
    //   // this.desserts.sort((a, b) => {
    //   //   return b.createDate - a.createDate;
    //   // });
    //   this.usersFilter = this.users;
    // },
    // async getTickets() {
    //   const querySnapshot = await getDocs(collection(db, "tickets"));
    //   querySnapshot.forEach((doc) => {
    //     // doc.data() is never undefined for query doc snapshots
    //     console.log(doc.id, " => ", doc.data());
    //     this.desserts.push(doc.data());
    //     this.desserts.sort((a, b) => {
    //       return b.createTime - a.createTime;
    //     });
    //   });
    //   this.isLoading = false;
    // },
    async getTickets() {
      const first = query(
        collection(db, "tickets"),
        orderBy("createTime", "asc"),
        limit(50)
      );
      const documentSnapshots = await getDocs(first);
      // console.log(documentSnapshots);
      documentSnapshots.forEach((doc) => {
        let data;
        data = JSON.parse(JSON.stringify(doc.data()));
        // console.log(doc.id, " => ", doc.data());
        this.desserts.push(data);
      });

      this.lastVisible =
        documentSnapshots.docs[documentSnapshots.docs.length - 1];
      this.isLoading = false;
    },
    async next() {
      if (this.lastVisible) {
        const next = query(
          collection(db, "tickets"),
          orderBy("createTime", "asc"),
          startAfter(this.lastVisible),
          limit(250)
        );

        const documentSnapshots = await getDocs(next);

        if (documentSnapshots.docs.length == 0) {
          this.$snackbar.add(`沒有更多了`, { color: "success" });
          this.lastVisible = "";
        } else if (documentSnapshots.docs.length < 250) {
          this.lastVisible = "";
        } else {
          this.lastVisible =
            documentSnapshots.docs[documentSnapshots.docs.length - 1];
        }

        documentSnapshots.forEach((doc) => {
          let data;
          data = JSON.parse(JSON.stringify(doc.data()));
          console.log(doc.id, " => ", doc.data());
          this.desserts.push(data);
        });
      } else {
        this.$snackbar.add(`沒有更多了`, { color: "success" });
        this.lastVisible = "";
      }
    },
    editItem(item) {
      this.editedIndex = this.desserts.indexOf(item);
      this.template = Object.assign({}, item);
      this.dialog = true;
    },
    deleteItem(item) {
      this.editedIndex = this.desserts.indexOf(item);
      this.template = Object.assign({}, item);
      this.dialogDelete = true;
    },
    async deleteItemConfirm() {
      const q = query(
        collection(db, "tickets"),
        where(documentId(), "==", this.template.ticketId)
      );

      const querySnapshot = await getDocs(q);
      await deleteDoc(doc(db, "tickets", querySnapshot._docs[0].id));
      this.$snackbar.add(`刪除成功`, { color: "success" });
      this.desserts = [];
      this.getTickets();
      this.closeDelete();
    },
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.template = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
        this.$refs.form.reset();
        this.usersSelected = [];
      });
    },
    closeDelete() {
      this.dialogDelete = false;
      this.$nextTick(() => {
        this.template = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    async save() {
      // if (this.usersSelected.length > 0) {
      if (this.editedIndex > -1) {
        console.log("修改");
        const q = query(
          collection(db, "tickets"),
          where("ticketId", "==", this.template.ticketId)
        );
        const querySnapshot = await getDocs(q);
        await setDoc(
          doc(db, "tickets", querySnapshot._docs[0].id),
          this.template
        );
        this.desserts = [];
        this.getTickets();
        this.close();
      } else {
        if (this.$refs.form.validate()) {
          let data = {};
          console.log("新增");
          data.beUsed = false;
          data.createTime = Number(this.timest());
          data.ticketKind = this.template.ticketKind;
          data.ticketName = this.template.ticketName;
          data.ticketNo = this.template.ticketNo;
          data.compaignDescription = this.template.compaignDescription;
          data.compaignName = this.template.compaignName;
          data.expiredDate = this.template.expiredDate;
          data.releaseDate = this.template.releaseDate;
          data.url = this.template.url;
          data.verificationCode = this.template.verificationCode;
          let createdId = doc(collection(db, "env")).id;
          data.ticketId = createdId;
          data.userNo = "";
          data.compNo = "";
          await setDoc(doc(db, "tickets", createdId), data);

          this.usersSelected = [];
          this.desserts = [];
          this.getTickets();
          this.$snackbar.add(`修改完成`, { color: "success" });
          this.close();
        }
      }
      // } else {
      //   this.$snackbar.add(`未選取傳送對象`, { color: "error" });
      // }
    },
    getItemId(item) {
      return item.ticketId; // Must be uid of record (would be nice if v-data-table exposed a "getItemKey" method)
    },
    toggleExpand(props) {
      const item = props.item;
      const id = this.getItemId(item);
      if (props.isExpanded && this.transitioned[id]) {
        // If we're expanded and not in the process of closing, close
        this.closeExpand(item);
      } else {
        // If we're closed or in the process of closing, expand
        // Stop us from closing if a close transition was started
        clearTimeout(this.closeTimeouts[id]);
        // Tell v-data-table to add the expansion content for the item
        props.expand(true);
        // Show expansion content with transition animation after it's had time to get added to the DOM
        this.$nextTick(() => this.$set(this.transitioned, id, true));
        // Hide all other expanded items if single-expand
        if (this.singleExpand)
          this.$nextTick(() =>
            this.expanded.forEach((i) => i !== item && this.closeExpand(i))
          );
      }
    },
    closeExpand(item) {
      const id = this.getItemId(item);
      // Mark that this item is in the process of closing
      this.$set(this.transitioned, id, false);
      // Remove expansion content from DOM after transition animation has had enough time to finish
      this.closeTimeouts[id] = setTimeout(
        () => this.$refs.vDataTable.expand(item, false),
        600
      );
    },
    timeConverter(UNIX_timestamp) {
      var a = new Date(UNIX_timestamp * 1000);
      var year = a.getFullYear();
      var month = a.getMonth() + 1;
      var date = a.getDate();
      var time =
        year +
        "-" +
        month.toString().padStart(2, "0") +
        "-" +
        date.toString().padStart(2, "0");
      return time;
    },
    timest() {
      var tmp = Date.parse(new Date()).toString();
      tmp = tmp.substr(0, 10);
      return tmp;
    },
    formatDate(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      return [year, month, day].join("-");
    },
    formatTime(date) {
      var d = new Date(date),
        hour = "" + d.getHours(),
        minute = d.getMinutes();

      return [hour, minute].join(":");
    },
    async expiredVerification() {
      if (this.daysBeforeExpiration) {
        let vm = this;
        this.desserts = [];
        await this.getTickets();
        let daysBeforeExpirationArray = this.desserts.filter(function (item) {
          return (
            new Date(item.expiredDate).getTime() -
              new Date(Date.now()).getTime() <=
            3600 * 1000 * 24 * vm.daysBeforeExpiration
          );
        });
        this.desserts = daysBeforeExpirationArray;
      } else {
        this.desserts = [];
        this.getTickets();
      }
    },
    handleScroll() {
      // console.log(
      //   window.scrollY,
      //   window.screen.height,
      //   document.body.scrollHeight
      // );
      this.offsetTop = window.scrollY;
    },
    exportExcel() {
      const workbook = new ExcelJs.Workbook(); // 創建試算表檔案
      const sheet = workbook.addWorksheet("票券列表"); //在檔案中新增工作表 參數放自訂名稱

      sheet.getColumn(1).width = 13;
      sheet.getColumn(2).width = 13;
      sheet.getColumn(3).width = 33;
      sheet.getColumn(4).width = 13;
      sheet.getColumn(5).width = 13;
      sheet.getColumn(6).width = 20;
      sheet.getColumn(7).width = 13;
      sheet.getColumn(8).width = 13;
      sheet.getColumn(9).width = 13;
      sheet.getColumn(10).width = 13;
      sheet.getColumn(11).width = 13;
      sheet.getColumn(12).width = 33;
      sheet.getColumn(13).width = 13;

      let data = [];
      this.desserts.forEach(function (item) {
        data.push([
          item.ticketKind,
          item.compaignName,
          item.ticketName,
          item.compNo,
          item.userNo,
          item.ticketNo,
          item.ticketGroup,
          item.releaseDate,
          item.expiredDate,
          item.contractExpiredDate,
          item.beUsed,
          item.url,
          item.verificationCode,
        ]);
      });
      sheet.addTable({
        // 在工作表裡面指定位置、格式並用columsn與rows屬性填寫內容
        name: "table名稱", // 表格內看不到的，算是key值，讓你之後想要針對這個table去做額外設定的時候，可以指定到這個table
        ref: "A1", // 從A1開始
        columns: [
          { name: "分類", defaultColWidth: 10 },
          { name: "活動名稱", defaultColWidth: 100 },
          { name: "票券名稱" },
          { name: "公司" },
          { name: "對象" },
          { name: "票券編號" },
          { name: "票券群組" },
          { name: "發布日期" },
          { name: "過期日期" },
          { name: "合約效期" },
          { name: "已使用" },
          { name: "網址" },
          { name: "驗證碼" },
        ],
        rows: data,
      });

      // 表格裡面的資料都填寫完成之後，訂出下載的callback function
      // 異步的等待他處理完之後，創建url與連結，觸發下載
      workbook.xlsx.writeBuffer().then((content) => {
        const link = document.createElement("a");
        const blobData = new Blob([content], {
          type: "application/vnd.ms-excel;charset=utf-8;",
        });
        link.download = `統一企業集團特約商店 ${this.formatDate(
          new Date()
        )}.xlsx`;
        link.href = URL.createObjectURL(blobData);
        link.click();
      });
    },
  },
};
</script>
<style></style>
